import CryptoJS from 'crypto-js'
window.CryptoJS = CryptoJS
import config from '../../static/config/config.json'

let util = {}
export default util

/**
 * AES 加密
 */
util.encrypt = function (content) {
    let key  = CryptoJS.enc.Utf8.parse(config.skey)
    var encryptResult = CryptoJS.AES.encrypt(content, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    })
    return encryptResult.toString()
}

/**
 * AES 解密
 */
util.decrypt = function (content) {
    let key  = CryptoJS.enc.Utf8.parse(config.skey)
    var encryptResult = CryptoJS.AES.decrypt(content, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    })
    return encryptResult.toString(CryptoJS.enc.Utf8)
}

/**
 * 检查一个变量是不是JSON对象
 * input： any
 * return: true or false
*/
util.isJson = function (data) {
    try {
        JSON.parse(data)
        return true
    } catch (err) {
        return false
    }
}

/**
 * JSON对象反序列化
 * input： any
 * return: object or null
*/
util.parse = function (data) {
    if (data && util.isJson(data)) return JSON.parse(data)
    return null
}

/**
 * 从本地存储中取出当前登录的对象(固定方法，可一般化)
 * input： null
 * return: 本地存储的user
    {
        iid: "23776",
        cardtype: "1",                          //法人/负责人证件类型 1 身份证 2 护照3 港澳居民往来内地通行证4 台湾居民往来大陆通行证
        uuid: "P201704201441575931061292",      //用户唯一ID
        loginname: "peixiaokai",                //用户登录名
        isauthuser: "1",                        //是否实名：1-已实名；0-未实名
        authlevel: "3",                         //实名等级：1-初级；2-中级；3-高级；6：实人
        cardid: "370202198712083558",           //身份证号码（已实名的用户，身份证号码才具有真实性
        cardObverse: "",                        //身份证复印件正面
        cardReverse: "",                        //身份证复印件反面
        cardStarTime: "",                       //身份证发放日期
        cardEndTime: "",                        //身份证有效截止日期
        code: "",                               //用户编码
        name: "裴晓凯",                         //用户姓名（已实名的用户，姓名才具有真实性）
        sex: "0",                               //性别0：男，1：女
        nation: "01",                           //民族，见国标GB3304-91
        birth: "1987-12-08",                    //出生日期
        mobile: "18669729607"                   //手机号码
        email: "502177521@qq.com",              //电子邮箱
        address: "",                            //地址
        regtime: "Thu Apr 20 14:41:57 CST 20",  //注册时间
        logintime: "Thu Jun 13 11:21:19 CST 20",//上一次登录时间
    }
*/
util.getLocalUser = function (key = 'login_user') {
    let userInfo = localStorage.getItem(key) || {}
    if (util.isJson(userInfo)) userInfo = JSON.parse(userInfo)
    return userInfo
}
/**
 * 本地存储中设置当前登录的对象(固定方法，可一般化)
 * input： null
 * return: undefined
*/
util.setLocalUser = function (userInfo, key = 'login_user') {
    if (!Array.isArray(userInfo) && typeof userInfo != 'object') {
        return localStorage.setItem(key, userInfo)
    } else {
        return localStorage.setItem(key, JSON.stringify(userInfo))
    }
}
/**
 * 判断传入的数据是否非空
 * input： any
 * return： Boolean 非空： true， 包含空值： false
 */
util.VerifyValues = function (item) {
    debugger
    //处理字符串
    if (typeof item == 'string') return !!item
    //处理数组
    if (Array.isArray(item)) return item.length > 0
    //处理对象
    let result = true
    if (typeof item == 'object') {
        let keys = Object.keys(item)
        let len = keys.length

        for (let i = 0; i < len; i++) {
 if(keys[i]=="desc"){
    continue;
 }
              if(keys[i]!="depart"||keys[i]!="matter"||keys[i]!="desc") {
                if (!item[keys[i]] || item[keys[i]] == '') {
                    result = false
                    break
                }
              } 
        }
    }
    return result
}

/**
 * 格式化日期
 * input： String， Date
 * return： String 'yyyy-MM-dd' => '2019-09-04'
*/
util.formatDate = function (date = new Date(), fmt = 'yyyy-MM-dd') {
    let o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length))
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
    return fmt
}


util.timestampToTime = function (timestamp) {
    debugger
    timestamp=timestamp+'';
    if((timestamp+'').length==10){
        var date = new Date(Number(timestamp+'000'));
    }else{
        var date = new Date(Number(timestamp));
    }
   //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';

          var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
   
          var D = date.getDate() + ' ';
   
           var h = date.getHours() + ':';
   
          var  m = date.getMinutes() + ':';
   
          var s = date.getSeconds();
   
    return Y + M + D;
}

